import { render, staticRenderFns } from "./moblie-fotter.vue?vue&type=template&id=cae5e4c2&scoped=true&"
import script from "./moblie-fotter.vue?vue&type=script&lang=js&"
export * from "./moblie-fotter.vue?vue&type=script&lang=js&"
import style0 from "./moblie-fotter.vue?vue&type=style&index=0&id=cae5e4c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae5e4c2",
  null
  
)

export default component.exports